import http from '../jslibs/axios/http';

//案例管理 案例列表
export const getCaseList = data => (http.get('/v1/cms/Project', data));

//案例管理 添加案例
export const addCase = data => (http.post('/v1/cms/Project', data));

//案例管理 删除案例
export const deleteCase = uuid => (http.delete(`/v1/cms/Project/${uuid}`));

//案例管理 编辑案例
export const editCase = data => (http.put(`/v1/cms/Project/${data.id}`, data));

//案例管理 案例详情
export const caseDetail = uuid => (http.get(`/v1/cms/Project/${uuid}`));

//案例管理 案例行业分类列表
export const getCaseClass = data => (http.get('/v1/cms/CaseClass', data));

//案例管理 新增案例行业分类
export const addCaseClass = data => (http.post('/v1/cms/CaseClass', data));

//案例管理 编辑案例行业分类
export const editCaseClass = data => (http.put(`/v1/cms/CaseClass/${data.id}`, data));

//案例管理 删除案例行业分类
export const deleteCaseClass = uuid => (http.delete(`/v1/cms/CaseClass/${uuid}`));